import React from 'react';

// DEPENDENCIES
import { createPortal } from 'react-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// HOOKS
import { useEpostContext } from 'helpers/getEpostData';
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// LOCAL COMPONENTS
import RebillEpostSidebar from '../../deliveryLog/parts/RebillEpostSidebar';

// MAIN COMPONENTS
export const EpostSidebar = () => {

  // HOOKS
  const { refetchRecord, recordID } = useRecordContext();

  // RENDER
  return createPortal(
    <Sidebar
      name="epostSaveSidebar"
      title="E-Post Deal Package to Accounting"
    >
      <Sidebar.Form
        method="PUT"
        endpoint={makePath(ENDPOINTS.sales.epost.save, recordID)}
        onSuccess={() => refetchRecord()}
        loadingMessage="Submitting E-Post"
        errorMessage="Unable to submit E-Post."
        successMessage="E-Post submitted successfully."
        buttons={{
          submit: {
            variant: 'success',
            label: 'E-Post',
            icon: 'checkmark'
          }
        }}
      >
        <Form.Col>
          <p><big>Are you sure you want to resend the deal package to accounting to be E-Posted?</big></p>
        </Form.Col>
      </Sidebar.Form>
    </Sidebar>,
    document.body
  );  
}

const EpostSidebarButton = props => {

  // HOOKS
  const { epostData } = useEpostContext();

  // VARIABLES
  const isLoaded = epostData !== undefined;
  const isRebill = epostData?.is_rebill || epostData?.rebill_requested;

  // RENDER
  return isRebill ? (
    <RebillEpostSidebar.Button
      name="epostSidebar"
      label="E-Post"
      icon="email"
      {...props}
    />
  ) : (
    <Sidebar.Button
      name="epostSaveSidebar"
      label="E-Post"
      icon={!isLoaded ? {
        use: 'loader',
        className: 'spin'
      } : 'email'}
      disabled={!isLoaded}
      {...props}
    />
  );
};
EpostSidebar.Button = EpostSidebarButton;

// EXPORT
export default EpostSidebar;
